import { render } from "./RiProdoffering06.vue?vue&type=template&id=ee521aa0"
import script from "./RiProdoffering06.vue?vue&type=script&lang=js"
export * from "./RiProdoffering06.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiProdoffering06.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ee521aa0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ee521aa0', __exports__)) {
    api.reload('ee521aa0', __exports__)
  }
  
  module.hot.accept("./RiProdoffering06.vue?vue&type=template&id=ee521aa0", () => {
    api.rerender('ee521aa0', render)
  })

}


export default __exports__